import { User } from "contexts/types/application-context-types";

export function isUserGerente(user: User): boolean {
  return (
    user?.userData.type === "PARCEIRO_GERENTE_VAREJO" ||
    user?.userData.type === "PARCEIRO_GERENTE_ESTRATEGICO"
  );
}
